import React from 'react';
import PropTypes from 'prop-types';
import ReactCodeInput from 'react-code-input';

const CodeInput = ({
  name = 'code',
  inputMode = 'numeric',
  type = 'text',
  fields = 6,
  value = '',
  ...other
}) => (
  <ReactCodeInput
    name={name}
    inputMode={inputMode}
    type={type}
    fields={fields}
    value={value}
    inputStyle={{
      margin: '3px',
      width: '30px',
      fontSize: '22px',
      height: '40px',
      textAlign: 'center',
      backgroundColor: '#f1f7fc',
      color: '#000',
      border: 'none',
      borderRadius: '5px',
      borderBottom: '3px solid #4791dc',
      outline: 'none',
    }}
    inputStyleInvalid={{
      margin: '3px',
      width: '30px',
      fontSize: '22px',
      height: '40px',
      textAlign: 'center',
      backgroundColor: '#fae7e7',
      color: '#000',
      border: 'none',
      borderRadius: '5px',
      borderBottom: '3px solid #db4747',
      outline: 'none',
    }}
    {...other}
  />
);
CodeInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  inputMode: PropTypes.string,
  type: PropTypes.string,
  fields: PropTypes.number,

};

export default CodeInput;
